import {ValidationErrors, AbstractControl, Validators, FormControl} from '@angular/forms';
import * as moment from 'moment';


function isEmptyInputValue(value: any): boolean {
  return (value == null || value === '' || value.length === 0);
}

const FISCAL_CODE = /^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/;
const PHONE_NUMBER = '^([()\\- x+]*\\d[()\\- x+]*){4,16}$';
const PHONE_NUMBER_MG = '^((00|\\+)39[. ]??)??3\\d{2}[. ]??\\d{6,7}$';
const ALL_NUMBER = '^[+|-]?([0-9]*[.|,]?)*$';
const INT_NUMBER_POS = '^[0-9]+$';
const INT_NUMBER_POS_NOT_ZERO = '^[1-9][0-9]*$';
const NOT_NEGATIVE = '^\\+?\\d+(?:\\.|,)+\\d+(?:\\.|,)?\\d*$';
const DATE_FORMAT = 'DD/MM/YYYY';
const DECIMAL_NUMBER_2_POS = '^[+-]?[0-9]{1,9}(?:\.[0-9]{1,2})?$';
const IPv4 = '^(?:(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(\\.(?!$)|$)){4}$';
const LATITUDE = '^[-+]?([1-8]?\\d(\\.\\d+)?|90(\\.0+)?)$';
const LONGITUDE = '^[-+]?(180(\\.0+)?|((1[0-7]\\d)|([1-9]?\\d))(\\.\\d+)?)$';
const EMAIL = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;


export class KoncentroValidators {

  /**
   * Validators that test the input on regex
   *
   * @param {string} pattern for regex
   * @returns {ValidationErrors | null}
   */
  public static pattern (pattern: string): ValidationErrors | null {
        let regex: RegExp;
    regex = new RegExp(pattern);

    return (control: AbstractControl): ValidationErrors | null => {
      if (isEmptyInputValue(control.value)) {
        return null;
      }
      return regex.test(control.value) ? null : { 'pattern' : true };
    }
  }

 /**
   * Validators that require a valid latitude
   *
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
  public static latitude(control: AbstractControl): ValidationErrors | null {
    let regex: RegExp;

    if (isEmptyInputValue(control.value)) {
      return null;
    }

    regex = new RegExp(LATITUDE);
    return regex.test(control.value) ? null : { 'latitude' : true };
  }


 /**
   * Validators that require a valid longitude
   *
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
  public static longitude(control: AbstractControl): ValidationErrors | null {
    let regex: RegExp;

    if (isEmptyInputValue(control.value)) {
      return null;
    }

    regex = new RegExp(LONGITUDE);
    return regex.test(control.value) ? null : { 'longitude' : true };
  }



  /**
   * Validators that require a valid phone number
   *
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
  public static phone(control: AbstractControl): ValidationErrors | null {
    let regex: RegExp;
    if (isEmptyInputValue(control.value)) {
      return null;
    }

    regex = new RegExp(PHONE_NUMBER);
    return regex.test(control.value) ? null : { 'phone' : true };
  }




  /**
   * Validators that require a valid phone number for Magazzini Gabrielli
   *
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
   public static phone_mg(control: AbstractControl): ValidationErrors | null {
    let regex: RegExp;
    if (isEmptyInputValue(control.value)) {
      return null;
    }

    regex = new RegExp(PHONE_NUMBER_MG);
    return regex.test(control.value) ? null : { 'phone_mg' : true };
  }


  /**
   * Validators that require a valid not null phone number
   *
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
  public static phoneRequired(control: AbstractControl): ValidationErrors | null {
    let regex: RegExp;
    if (isEmptyInputValue(control.value)) {
      return { 'required': true };
    }

    regex = new RegExp(PHONE_NUMBER);
    return regex.test(control.value) ? null : { 'phone' : true };
  }



  /**
   * Validators that require a valid not null phone number for Magazzini Gabrielli
   *
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
   public static phoneRequired_mg(control: AbstractControl): ValidationErrors | null {
    let regex: RegExp;
    if (isEmptyInputValue(control.value)) {
      return { 'required': true };
    }

    regex = new RegExp(PHONE_NUMBER_MG);
    return regex.test(control.value) ? null : { 'phone_mg' : true };
  }



  /**
   * Validators that require a valid italian fiscal code
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
  public static fiscalCode(control: AbstractControl): ValidationErrors | null {
    let regex: RegExp;
    if (isEmptyInputValue(control.value)) {
      return null;
    }

    // fiscal code can be only nunber under 11chars (onlus fiscal code)
    if (control.value.length <= 11) {
     // return this.number(control);
     return KoncentroValidators.number(control);
    }

    const value: string = control.value;

    regex = new RegExp(FISCAL_CODE);
    return regex.test(value.toUpperCase()) ? null : { 'fiscalCode' : true };
  }

  /**
   * Validators that require a valid not null italian fiscal code
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
  public static fiscalCodeRequired(control: AbstractControl): ValidationErrors | null {
    let regex: RegExp;
    if (isEmptyInputValue(control.value)) {
      return { 'required': true };
    }

    const value: string = control.value;

    regex = new RegExp(FISCAL_CODE);
    return regex.test(value.toUpperCase()) ? null : { 'fiscalCode' : true };
  }

  /**
   * Validators that require a valid number
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
  public static number(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }

    const regex: RegExp = new RegExp(ALL_NUMBER);
    return regex.test(control.value) ? null : { 'number' : true };
  }

  /**
   * Validators that require a valid not negative number
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
  public static numberNotNegative(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }

    const regex: RegExp = new RegExp(NOT_NEGATIVE);
    return regex.test(control.value) ? null : { 'numberNotNegative' : true };
  }

  /**
   * Validators that require a valid not negative integer
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
  public static integerNotNegative(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }

    const regex: RegExp = new RegExp(INT_NUMBER_POS);
    return regex.test(control.value) ? null : { 'integerNotNegative' : true };
  }

   /**
   * Validators that require a valid positive integer
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
  public static integerPositive(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }

    const regex: RegExp = new RegExp(INT_NUMBER_POS_NOT_ZERO);
    return regex.test(control.value) ? null : { 'integerPositive' : true };
  }

    /**
     * Validators that require a valid not negative integer
     * @param {AbstractControl} control
     * @returns {ValidationErrors | null}
     */
    public static decimalNotNegative(control: AbstractControl): ValidationErrors | null {
      if (isEmptyInputValue(control.value)) {
        return null;
      }

      const regex: RegExp = new RegExp(DECIMAL_NUMBER_2_POS);
      return regex.test(control.value) ? null : { 'decimal2NotNegative' : true };
    }


  /**
   * Validators that require a valid ip address
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
  public static ipAddress(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }

    const regex: RegExp = new RegExp(IPv4);
    return regex.test(control.value) ? null : { 'ipAddress' : true };
  }

  public static dateNotAfter(dateX: Date): ValidationErrors | null {
    if (dateX === undefined || dateX === null) {
      dateX = new Date();
    }

    return (control: AbstractControl): ValidationErrors | null => {
      if (isEmptyInputValue(control.value)) {
        return null;
      }
      const value = new Date(control.value);
      return value <= dateX ? null : {'dateNotAfter': true };
    };
  }

  /**
   * Validators that require a valid or null email
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
  public static emailOrEmpty(control: AbstractControl): ValidationErrors | null {
    let regex: RegExp;
    const value: string = control.value;

    if (isEmptyInputValue(value)) {
      return null;
    }

    regex = new RegExp(EMAIL);
    return regex.test(value.toLowerCase()) ? null : { 'email' : true };
    // Il Validator standard di Angular non prevede estensione obbligatoria (.com, .it ecc)
    //return Validators.email(control);
  }

  /**
   * Validator for zip codes
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
   public static zipCodeValidator(control: AbstractControl): ValidationErrors | null {
    const value: string = control.value;

    if (isEmptyInputValue(value)) {
      return null;
    }

    const regex: RegExp = new RegExp(ALL_NUMBER);
    return regex.test(value) && value.length >= 5 ? null : { 'zipCode' : true };

  }

  public static checkDateMinorOther (otherControlName: string) {

    let thisControl: FormControl;
    let otherControl: FormControl;

    return function checkDateOtherValidate(control: FormControl) {

      if (!control.parent) {
        return null;
      }

      // Initializing the validator.
      if (!thisControl) {
        thisControl = control;
        otherControl = control.parent.get(otherControlName) as FormControl;
        if (!otherControl) {
          throw new Error('checkDateOther(): other control is not found in parent group');
        }
        // otherControl.valueChanges.subscribe(() => {
        //  thisControl.updateValueAndValidity();
        // });
      }

      if (!otherControl) {
        return null;
      }

      if (moment(otherControl.value).isAfter(thisControl.value)) {
        return {
          checkDateOther: true
        };
      }

      return null;

    }
  }

  public static checkDateMajorOther (otherControlName: string) {

      let thisControl: FormControl;
      let otherControl: FormControl;

      return function checkDateOtherValidate (control: FormControl) {

        if (!control.parent) {
          return null;
        }

        // Initializing the validator.
        if (!thisControl) {
          thisControl = control;
          otherControl = control.parent.get(otherControlName) as FormControl;
          if (!otherControl) {
            throw new Error('checkDateOther(): other control is not found in parent group');
          }
          // otherControl.valueChanges.subscribe(() => {
          //  thisControl.updateValueAndValidity();
          // });
        }

        if (!otherControl) {
          return null;
        }

        if (moment(otherControl.value).isBefore(thisControl.value)) {
          return {
            checkDateOther: true
          };
        }

        return null;

      }

  }

  /**
   * Validator for text input instead special characters
   * @param {AbstractControl} control
   * @returns {ValidationErrors | null}
   */
  public static noSpecialCharacters(control: AbstractControl): ValidationErrors | null {
    const alphanumericPattern = /^[a-zA-Z0-9]*$/;
    if (control.value && !alphanumericPattern.test(control.value)) {
      return { invalidFormat: true };
    }
    return null;

  }

  public static isEmptyInputValue(value: any): boolean {
    return (value == null || value === '' || value.length === 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/validators/koncentro-validators.ts